import { CommandBlock } from '@reflex/ui/components/content/CommandBlock';

interface CommandListProps {
  commands: string[];
  /**
   * Singular noun for the count label and copy aria-labels, e.g. `command`
   * renders "3 commands". Defaults to `command`.
   */
  label?: string;
  className?: string;
}

/**
 * Thin wrapper around the shared `CommandBlock` that computes a count-based
 * title from a singular `label` noun. Used by the blueprint detail panel for
 * the read-only Setup / Launch command lists.
 */
export function CommandList({ commands, label = 'command', className }: CommandListProps) {
  if (commands.length === 0) return null;
  const noun = commands.length === 1 ? label : `${label}s`;

  return (
    <CommandBlock commands={commands} title={`${commands.length} ${noun}`} className={className} />
  );
}
